import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/Skeleton';
import React from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
export const Iframe = props => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      freezeOnceVisible: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    isIntersecting,
    ref
  } = useIntersectionObserver(t0);
  if (!isIntersecting) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton isLoading={true} className="h-full w-full absolute top-0 left-0 bg-semantic-surface-faint" />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== ref) {
      t2 = <div ref={ref} className="h-full w-full relative">{t1}</div>;
      $[2] = ref;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] !== props) {
    t1 = <iframe {...props} />;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};